/*
 * バリデーション（案件メンバー関連）
 */
import { composeValidators } from '@/utils/libs/react-final-form/validate';
import { isURL } from '@/utils/libs/validator/format';
import { isRfpOfferMemberTypeCompany, isRfpOfferMemberTypeOutside, } from '@/utils/resources/rfp/rfpOfferMember';
import { validateEmail } from '@/utils/validate/common';
import { isRequiredText, strMax, isIncludedEmailDomain, isNotIncludedEmailDomain, } from '@/utils/validate/conditions';
/**
 * validation: メンバー登録済みのアドレス判定
 * @param registeredEmail メンバー登録済みのメールアドレスの配列
 */
export const validateAddedMemberEmail = (registeredEmails) => (value) => value && registeredEmails.includes(value)
    ? '既にメンバー体制に登録されているメールアドレスです'
    : undefined;
/**
 * validation: 利用可能なドメイン判定
 * @param enableDomains 利用可能なドメインの配列
 */
export const validateEnableDomain = (enableDomains) => (value, allValues) => {
    const memberType = allValues === null || allValues === void 0 ? void 0 : allValues.member_type;
    // 社内メンバー選択
    if (isRfpOfferMemberTypeCompany(memberType)) {
        return isNotIncludedEmailDomain(enableDomains, '社内メンバーでしょうか？ドメインが異なりますので、社外の場合は【共同提案メンバー（社外）】から追加ください')(value);
    }
    // 社外メンバー選択
    if (isRfpOfferMemberTypeOutside(memberType)) {
        return isIncludedEmailDomain(enableDomains, '社外メンバーでしょうか？同じドメインですので、社内の場合は【社内メンバー】から追加ください')(value);
    }
    return undefined;
};
/**
 * validation: メールアドレス
 * @param registeredEmails メンバー登録済みのメールアドレスの配列
 * @param enableDomains 利用可能なドメインの配列
 */
export const validateAddMemberEmail = (registeredEmails, enableDomains) => composeValidators(validateEmail, validateAddedMemberEmail(registeredEmails), validateEnableDomain(enableDomains));
/**
 * validation: 企業名
 */
export const validateAddMemberCompanyName = composeValidators(isRequiredText('企業名を入力してください'), strMax(50, '企業名は50文字以内で入力してください'));
/**
 * validation: 企業URL
 */
export const validateAddMemberCompanyURL = composeValidators(strMax(255, 'HPのURLは255文字以内で入力してください'), (value) => {
    if (!value || isURL(value)) {
        return undefined;
    }
    return 'HPのURLを入力してください';
});
